export var Urls;
(function (Urls) {
    Urls["ApprenticeshipForm"] = "/form/apprenticeship";
    Urls["Basket"] = "/basket";
    Urls["BespokeForm"] = "/form/bespoke";
    Urls["Error"] = "/error";
    Urls["FunctionalSkillsForm"] = "/form/functional-skills";
    Urls["Home"] = "/request-standard";
    Urls["OrderPlaced"] = "/order/placed";
    Urls["RegulatedForm"] = "/form/regulated";
    Urls["Request"] = "/requests";
    Urls["Unauthorised"] = "/common/unauthorised";
    Urls["TermsAndConditions"] = "https://live.onefile.co.uk/eula/TeesAndCees.aspx";
    Urls["Policies"] = "https://www.onefile.co.uk/policies/terms/";
})(Urls || (Urls = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVybHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksSUFhWDtBQWJELFdBQVksSUFBSTtJQUNaLG1EQUEyQyxDQUFBO0lBQzNDLDBCQUFrQixDQUFBO0lBQ2xCLHFDQUE2QixDQUFBO0lBQzdCLHdCQUFnQixDQUFBO0lBQ2hCLHdEQUFnRCxDQUFBO0lBQ2hELGtDQUEwQixDQUFBO0lBQzFCLHFDQUE2QixDQUFBO0lBQzdCLHlDQUFpQyxDQUFBO0lBQ2pDLDZCQUFxQixDQUFBO0lBQ3JCLDZDQUFxQyxDQUFBO0lBQ3JDLCtFQUF1RSxDQUFBO0lBQ3ZFLDhEQUFzRCxDQUFBO0FBQzFELENBQUMsRUFiVyxJQUFJLEtBQUosSUFBSSxRQWFmIn0=